import React from "react";
import BaseComponent from "../BaseComponent.js";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import Type from "../Global/Typography.js";
import NanoFlex from "./../Global/NanoFlex";
import Modal from "./../Global/Modal.js";
import Dropdown from "./../Nano/Dropdown.js";
import Input from "./../Nano/Input.js";
import MultipleSelectionDropdown from "./../Nano/MultipleSelectionDropdown.js";
import PasswordManagementModal from "./../Micro/PasswordManagementModal.js";

//IMAGES
import { ReactComponent as UserIcon } from "../Global/Icons/user.svg";
import { ReactComponent as NotaSimple } from "./../../images/notaSimple.svg";
import { ReactComponent as NotaN } from "../Global/Icons/nota-icon.svg";
import { ReactComponent as SearchIcon } from "../Global/Icons/search.svg";
import { ReactComponent as Delete } from "../Global/Icons/close.svg";
import { ReactComponent as FlagGB } from "../Global/Icons/flagGB.svg";
import { ReactComponent as FlagCN } from "../Global/Icons/flagCN.svg";

const multiple = nota.global.multiple;

const StyledHeader = styled.div`
  background: ${nota.color.main.default};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  width: 100%;
  position: sticky;
  z-index: 9;
  left: 0;
  top: 0;

  .header {
    height: ${multiple * 6 + "px"}; /*48px*/
    padding: 0 ${multiple * 2 + "px"};
    .headerWrapper {
      .logoWrapper {
        width: auto;
        cursor: ${(props) => (props.logoPointer ? "pointer" : "default")};
        .logoNota {
          display: flex;
        }
        .iconNota {
          height: 26px;
          width: auto;
          display: none;
        }
      }
      .headerSearch {
        position: relative;
        width: auto;
        margin-left: 95px;
        .clearAllWrapper {
          position: absolute;
          top: 7px;
          left: 0;
          background-color: ${nota.color.neutral.lightGrey};
          border-radius: 20px 0 0 20px;
          width: 18px;
          overflow: hidden;
          padding: 9px 6px;
          transition: all 300ms ease-in-out;
          height: 34px;
          cursor: pointer;
          .iconWrapper {
            width: auto;
            margin-top: 1px;
            svg {
              height: 8px;
              width: auto;
              path {
                fill: ${nota.color.neutral.NeuTwo};
              }
            }
          }
          .infoWrapper {
            opacity: 0;
            transition: opacity 200ms ease-in-out;
          }
          &:hover {
            transition: all 300ms ease-in-out;
            width: 550px;
            border-radius: 20px 20px 0 20px;
            .iconWrapper {
              svg {
                path {
                  fill: ${nota.color.main.mTwo};
                }
              }
            }
            .infoWrapper {
              opacity: 1;
              transition: opacity 500ms ease-in-out;
              transition-delay: 100ms;
              p {
                color: ${nota.color.main.mTwo};
              }
            }
          }
        }
      }

      .searchWrapper {
        width: 300px;
        position: relative;
        div {
          margin: 0;
          div {
            input {
              border: 0;
              width: 300px;
              border-radius: 20px 0 0 20px;
              padding: 9px 22px;
              padding-right: 40px;
            }
          }
        }
        .searchIconWrapper {
          position: absolute;
          height: auto;
          right: ${multiple + "px"};
          width: ${multiple * 3 + "px"};
          svg {
            width: 18px;
            height: 18px;
            path {
              fill: ${nota.color.main.default};
            }
          }
        }
      }

      .headerDropdownWrapper {
        width: auto;
        .dropDownContainer {
          border-color: ${nota.color.neutral.white};
          background-color: ${nota.color.neutral.white};
          border-left: 1px solid ${nota.color.main.default};
          width: 250px;
          border-radius: 0 20px 0 0;
          .dropDownWrapper {
            .inputDropDownWrapper {
              .infoDropDownWrapper {
                width: calc(100% - 20px);
                p {
                  color: ${nota.color.main.default};
                }
              }
              .iconDropDownWrapper {
                background-color: ${nota.color.neutral.white};
                width: auto;
                padding: 0;
                height: auto;
                margin-top: 12px;

                svg {
                  width: 10px;
                  height: 10px;
                  path {
                    fill: ${nota.color.main.default};
                  }
                }
              }
            }
            .dropdown-content {
              border-color: ${nota.color.neutral.white};
              right: -1px;
              width: calc(100% + 1px);
              box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
              max-height: unset;
              input {
                height: 40px;
              }
            }
          }
        }
      }
    }
    .userContainer {
      width: auto;
      .userWrapper {
        width: auto;

        .userIcon {
          cursor: pointer;
          position: relative;
        }

        .dropdown-content {
          left: unset;
          transform: translate(0%);
          right: -2.5px;

          .tooltipWrapper {
            min-width: 200px;
            border: 1px solid ${nota.color.neutral.NeuTwo};
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            padding: ${multiple + "px"}; /* 8px */
            position: relative;
            &:after,
            &:before {
              bottom: 100%;
              right: 5px;
              border: solid transparent;
              content: " ";
              height: 0;
              width: 0;
              position: absolute;
              pointer-events: none;
            }

            &:after {
              border-color: rgba(255, 255, 255, 0);
              border-bottom-color: ${nota.color.neutral.white};
              border-width: 8px;
              margin-right: 0px;
            }
            &:before {
              border-color: rgba(0, 168, 225, 0);
              border-bottom-color: ${nota.color.neutral.NeuTwo};
              border-width: 9px;
              margin-right: -1px;
            }
            .optionsWrapper {
              border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
              padding: ${multiple * 2 + "px"} 0;
              .optionLine {
                padding: ${multiple + "px"}; /* 8px */
                cursor: pointer;
                user-select: none;

                &:hover {
                  background-color: ${nota.color.neutral.lightGrey};
                  p {
                    color: ${nota.color.main.default};
                  }
                }
              }

              .specialOption {
                p {
                  b {
                    text-transform: uppercase;
                    color: ${nota.color.main.mTwo};
                  }
                }
              }

              .languageOption {
                cursor: pointer;
                padding: ${multiple + "px"} ${multiple / 2 + "px"};
                background-color: ${nota.color.neutral.lightGrey};
                margin-right: ${multiple + "px"};
                svg {
                  height: 35px;
                  width: auto;
                  path {
                    fill: ${nota.color.neutral.NeuTwo};
                  }
                }
                &:last-child {
                  margin-right: 0;
                }
              }
              .languageActive {
                pointer-events: none;
                background-color: ${nota.color.main.default};
                svg {
                  path {
                    fill: ${nota.color.neutral.white};
                  }
                }
              }

              .activeItem {
                p {
                  font-weight: bold;
                  color: ${nota.color.main.default};
                }
              }

              &:first-child {
                padding-top: ${multiple + "px"};
              }

              &:last-child {
                border-bottom: 0;
                padding-top: ${multiple + "px"};
                padding-bottom: 0;
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 800px) {
    .header {
      .headerWrapper {
        .logoWrapper {
          .logoNota {
            display: none;
          }
          .iconNota {
            display: flex;
          }
        }
        .headerSearch {
          margin-left: 24px;
          width: 100%;
          .searchWrapper {
            width: 100%;
            .inputContainer {
              width: 100%;
              .inputWrapper {
                input {
                  width: 100%;
                }
              }
            }
          }
          .headerDropdownWrapper {
            width: 100%;
            max-width: 35vw;
            .dropDownContainer {
              width: 100%;
              .dropDownWrapper {
                .inputDropDownWrapper {
                  min-width: auto;
                }
              }
            }
          }
          .clearAllWrapper {
            &:hover {
              width: 18px;
              border-radius: 20px 0px 0 20px;
              .infoWrapper {
                display: none;
              }
            }
          }
        }
      }
      .userContainer {
        display: none;
      }
    }
  }
`;
const _titles = ["original_title_noaccent", "local_title_noaccent", "format_title", "translated_title"];

export class Header extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      redirectToMySubscription: false,
      redirectToFaq: false,
      redirectToAboutUs: false,
      redirectToLogin: false,

      canRedirectToHome: false,

      showPasswordManagement: false,

      forceSelection: false,
      searchTitles: [],
      filter: this.getDefaultFilter(),
      canClearFilters: false,
    };

    this.requestId = 1;
  }

  getDefaultFilter = () => {
    return {
      term: "",
      isDefaultSearchTitles: true,
      selectedSearchTitles: [..._titles],
    };
  };

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onHeaderLanguageChange, false);
    window.addEventListener("setSearchFrom", this.setSearchFrom, false);
    window.addEventListener("clearSearch", this.clearSearch, false);
    window.addEventListener("clearHeader", this.clearSearch, false);
    window.addEventListener("deleteFilter", this.onDeleteFilter, false);

    this.validateCanRedirectToHome();

    this.getAllComponentsData();

    this.props.onFilterChange(this.state.filter);
  }

  componentDidUpdate(prevProps, prevState) {
    //Redirect's
    if (prevProps.render.match.path !== this.props.render.match.path || prevProps.displaySearch !== this.props.displaySearch) {
      this.validateCanRedirectToHome();
    }

    if (this.state.redirectToMySubscription) this.setState({ redirectToMySubscription: false });
    if (this.state.redirectToFaq) this.setState({ redirectToFaq: false });
    if (this.state.redirectToAboutUs) this.setState({ redirectToAboutUs: false });
    if (this.state.redirectToDailyUpdate) this.setState({ redirectToDailyUpdate: false });
    if (this.state.redirectToLogin) this.setState({ redirectToLogin: false });

    //Search
    if (JSON.stringify(prevState.filter) !== JSON.stringify(this.state.filter)) {
      this.requestId++;
      var requestId = this.requestId;
      setTimeout(() => {
        if (requestId === this.requestId) {
          this.saveHeaderRecapFilters();
          this.validateCanClearFilters();
          this.props.onFilterChange(this.state.filter);
        }
      }, 1000);
    }

    if (JSON.stringify(prevProps.filter) !== JSON.stringify(this.props.filter)) {
      this.setState({ filter: this.props.filter });
    }

    if (JSON.stringify(prevProps.advancedSearch) !== JSON.stringify(this.props.advancedSearch)) {
      this.validateCanClearFilters();
    }

    if (this.state.forceSelection) {
      this.setState({ forceSelection: false });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onHeaderLanguageChange, false);
    window.removeEventListener("setSearchFrom", this.setSearchFrom, false);
    window.removeEventListener("clearSearch", this.clearSearch, false);
    window.removeEventListener("clearHeader", this.clearSearch, false);
    window.removeEventListener("deleteFilter", this.onDeleteFilter, false);
  }

  onHeaderLanguageChange = () => {
    this.getAllComponentsData();
  };

  getAllComponentsData = () => {
    this.getTitles();
  };

  //Redirect's
  validateCanRedirectToHome = () => {
    this.setState({ canRedirectToHome: this.props.render.match.path !== "/" || this.props.displaySearch });
  };

  mySubscription = () => {
    this.setState({ redirectToMySubscription: true });
  };

  faq = () => {
    this.setState({ redirectToFaq: true });
  };

  aboutUs = () => {
    this.setState({ redirectToAboutUs: true });
  };

  dailyUpdate = () => {
    this.setState({ redirectToDailyUpdate: true });
  };

  logOut = () => {
    this.setState({ redirectToLogin: true });
  };

  clearSearch = () => {
    this.setState({
      /*Clear Header Filters*/
      filter: this.getDefaultFilter(),
      canClearFilters: false,
    });
  };

  //Language
  changeLanguage = (langId) => {
    window.dispatchEvent(new CustomEvent("languageChange", { detail: langId }));
  };

  validateCanClearFilters = () => {
    window.dispatchEvent(
      new CustomEvent("getRecapFilters", {
        detail: {
          excludeHeaderRecap: true,
          callback: (data) => {
            this.setState({ canClearFilters: data?.length > 0 });
          },
        },
      })
    );
  };

  triggerClearSearch = () => {
    window.dispatchEvent(new Event("clearSearch"));
  };

  onDeleteFilter = (e) => {
    if (!e.detail) return;

    let prevFilter = JSON.stringify(this.state.filter);
    let currentFilter = JSON.parse(prevFilter);
    e.detail.forEach((f) => {
      switch (f.field) {
        case "Term":
          currentFilter.term = "";
          break;
        case "SearchTitles":
          currentFilter.isDefaultSearchTitles = false;
          currentFilter.selectedSearchTitles = [];
          break;
      }
    });

    if (prevFilter !== JSON.stringify(currentFilter)) {
      /*Close Advanced Search*/
      window.dispatchEvent(new Event("closeAdvancedSearch"));
      this.setState({ filter: currentFilter });
    }
  };

  setSearchFrom = (e) => {
    let filter = { ...this.state.filter };
    switch (e.detail.menu) {
      case "SavedSearch":
        var selection = e.detail.filter;
        if (selection) {
          filter.term = selection.term;
          filter.selectedSearchTitles = selection.selectedSearchTitles;
        } else {
          filter = this.getDefaultFilter();
        }
        this.setState({ filter: filter, forceSelection: true }, () => {
          this.props.onFilterChange(this.state.filter);
        });
        break;
      case "SearchFromCard":
        var selection = e.detail.filter;
        if (selection) {
          filter.term = selection.term;
          filter.selectedSearchTitles = selection.selectedSearchTitles;
        } else {
          filter = this.getDefaultFilter();
        }
        this.setState({ filter: filter, forceSelection: true }, () => {
          this.props.onFilterChange(this.state.filter);
        });
        break;
    }
  };

  getTitles = () => {
    this.setState(
      {
        searchTitles: [
          {
            id: "local_title_noaccent",
            name: this.translation.advancedSearch.searchTitles.localTitle,
          },
          {
            id: "format_title",
            name: this.translation.advancedSearch.searchTitles.formatTitle,
          },
          {
            id: "original_title_noaccent",
            name: this.translation.advancedSearch.searchTitles.originalTitle,
          },
          {
            id: "translated_title",
            name: this.translation.advancedSearch.searchTitles.translatedTitle,
          },
          {
            id: "Keywords",
            name: this.translation.advancedSearch.searchTitles.keywords,
          },
          {
            id: "Concept_Descriptions",
            name: this.translation.advancedSearch.searchTitles.conceptsDescriptions,
          },
          {
            id: "PRODUCERS",
            name: this.translation.advancedSearch.searchTitles.productionCompanies,
          },
          {
            id: "DISTRIBUTORS",
            name: this.translation.advancedSearch.searchTitles.distributors,
          },
          {
            id: "HOST_CAST",
            name: this.translation.advancedSearch.searchTitles.hostCast,
          },
          {
            id: "EXECUTIVE_PRODUCER",
            name: this.translation.advancedSearch.searchTitles.producers,
          },
          {
            id: "DIRECTOR",
            name: this.translation.advancedSearch.searchTitles.directors,
          },
        ],
      },
      () => {
        this.saveHeaderRecapFilters();
      }
    );
  };

  onTermChange = (value) => {
    let filter = { ...this.state.filter };
    filter.term = value;
    this.setState({ filter: filter });
  };

  onSearchTitlesChange = (e) => {
    let forceSelection = false;
    let filter = { ...this.state.filter };
    filter.selectedSearchTitles = e.selected.map((v) => {
      return v.id;
    });

    if (filter.isDefaultSearchTitles && !e.isAllSelected) {
      if (filter.selectedSearchTitles.length > _titles.length && filter.selectedSearchTitles.filter((r) => _titles.includes(r)).length == _titles.length) {
        filter.selectedSearchTitles = filter.selectedSearchTitles.filter((v) => {
          return !_titles.includes(v);
        });
        forceSelection = true;
      }
    }

    if (filter.isDefaultSearchTitles && JSON.stringify(filter.selectedSearchTitles.sort()) !== JSON.stringify(this.getDefaultFilter().selectedSearchTitles.sort())) {
      filter.isDefaultSearchTitles = false;
    }

    filter.allSearchTitles = e.isAllSelected;
    this.setState({ filter: filter, forceSelection: forceSelection });
  };

  onPasswordManagementClick = () => {
    this.setState({ showPasswordManagement: true });
  };

  saveHeaderRecapFilters = () => {
    let recap = [];

    if (this.state.filter.term && this.state.searchTitles && this.state.filter.selectedSearchTitles !== null) {
      //Term
      recap.push({ translation: "header.searchTerm", field: "Term", values: [{ name: this.state.filter.term }] });

      //Search Titles
      let titleValue;
      //All Selected
      if (this.state.filter.allSearchTitles) {
        titleValue = this.state.searchTitles;
      } else {
        //Only Titles Selected
        if (this.state.filter.selectedSearchTitles.length == _titles.length && this.state.filter.selectedSearchTitles.every((r) => _titles.includes(r))) {
          titleValue = [{ name: this.translation.header.searchTitlesOnly }];
        } else {
          titleValue = this.state.searchTitles.filter((b) => this.state.filter.selectedSearchTitles.includes(b.id));
        }
      }

      recap.push({
        translation: "header.searchTitles",
        field: "SearchTitles",
        values: titleValue,
        isAllSelected: this.state.filter.allSearchTitles,
      });
    }

    sessionStorage.setItem("headerRecapFilters", JSON.stringify(recap));
  };

  render() {
    if (this.state.redirectToMySubscription) return <Redirect to="/mySubscription" />;
    if (this.state.redirectToFaq) return <Redirect to="/faq" />;
    if (this.state.redirectToAboutUs) return <Redirect to="/aboutUs" />;
    if (this.state.redirectToDailyUpdate) return <Redirect to="/dailyUpdate" />;
    if (this.state.redirectToLogin) return <Redirect to="/login" />;

    let langId = this.getLanguage();
    return (
      <StyledHeader logoPointer={this.state.canRedirectToHome}>
        <NanoFlex className="header">
          <NanoFlex className="headerWrapper" justifyContent={"flex-start"}>
            <NanoFlex className="logoWrapper" justifyContent={"flex-start"}>
              <Link to="/">
                <NotaSimple className="logoNota" />
                <NotaN className="iconNota" />
              </Link>
            </NanoFlex>

            <NanoFlex className="headerSearch">
              <NanoFlex className="searchWrapper" justifyContent={"flex-start"}>
                <Input
                  id={0}
                  name="search"
                  title={null}
                  defaultValue={this.state.filter.term}
                  placeholder={this.translation.geral.search + "..."}
                  error={false}
                  onChangeAction={this.onTermChange}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      window.dispatchEvent(new CustomEvent("submitSearch"));
                    }
                  }}
                />
                <NanoFlex className="searchIconWrapper">
                  <SearchIcon />
                </NanoFlex>
              </NanoFlex>
              <NanoFlex className="headerDropdownWrapper" justifyContent={"flex-start"}>
                <MultipleSelectionDropdown
                  options={this.state.searchTitles}
                  onChangeSelection={this.onSearchTitlesChange}
                  selected={this.state.filter.selectedSearchTitles}
                  forceSelection={false}
                  hideSelectAll={true}
                  customDisplayString={(event) => {
                    if (event.selectedIds.length == _titles.length && event.selectedIds.every((r) => _titles.includes(r))) {
                      event.handled = true;
                      event.displayString = this.translation.header.searchTitlesOnly;
                    }
                  }}
                />
              </NanoFlex>
              {this.state.canClearFilters && (
                <NanoFlex className="clearAllWrapper" justifyContent={"flex-start"} onClick={this.triggerClearSearch}>
                  <NanoFlex className="iconWrapper">
                    <Delete />
                  </NanoFlex>
                  <NanoFlex className="infoWrapper">
                    <Type.p>{this.translation.header.clearAllFilters}</Type.p>
                  </NanoFlex>
                </NanoFlex>
              )}
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="userContainer" justifyContent={"flex-end"}>
            <NanoFlex className="userWrapper">
              <Dropdown
                onClickOutsideClose
                main={
                  <NanoFlex className="userIcon" justifyContent={"flex-end"}>
                    <UserIcon className="userIcon" />
                  </NanoFlex>
                }
                content={
                  <NanoFlex>
                    <NanoFlex className="tooltipWrapper" flexDirection={"column"}>
                      <NanoFlex className="optionsWrapper">
                        <NanoFlex className={`languageOption ${langId === null ? "languageActive" : ""}`} onClick={() => this.changeLanguage(null)}>
                          <FlagGB />
                        </NanoFlex>
                        <NanoFlex className={`languageOption ${langId === 1 ? "languageActive" : ""}`} onClick={() => this.changeLanguage(1)}>
                          <FlagCN />
                        </NanoFlex>
                      </NanoFlex>
                      <NanoFlex className="optionsWrapper" flexDirection={"column"}>
                        <NanoFlex className={`optionLine ${this.props.render.match.path === "/mySubscription" && !this.props.selectedMenu ? "activeItem" : ""}`} alignItems={"flex-end"} justifyContent={"flex-end"} onClick={this.mySubscription}>
                          <Type.p>{this.translation.myCompanySubscription.title}</Type.p>
                        </NanoFlex>
                        <NanoFlex className="optionLine" alignItems={"flex-end"} justifyContent={"flex-end"} onClick={this.onPasswordManagementClick}>
                          <Type.p>{this.translation.passwordManagement.title}</Type.p>
                        </NanoFlex>
                      </NanoFlex>
                      <NanoFlex className="optionsWrapper" flexDirection={"column"}>
                        <NanoFlex className={`optionLine ${this.props.render.match.path === "/faq" && !this.props.selectedMenu ? "activeItem" : ""}`} alignItems={"flex-end"} justifyContent={"flex-end"} onClick={this.faq}>
                          <Type.p>{this.translation.faq.title}</Type.p>
                        </NanoFlex>
                        <NanoFlex className={`optionLine ${this.props.render.match.path === "/aboutUs" && !this.props.selectedMenu ? "activeItem" : ""}`} alignItems={"flex-end"} justifyContent={"flex-end"} onClick={this.aboutUs}>
                          <Type.p>{this.translation.aboutUs.title}</Type.p>
                        </NanoFlex>
                      </NanoFlex>
                      <NanoFlex className="optionsWrapper">
                        <NanoFlex className="optionLine specialOption" onClick={this.logOut}>
                          <Type.p>
                            <b>{this.translation.header.logOut}</b>
                          </Type.p>
                        </NanoFlex>
                      </NanoFlex>
                    </NanoFlex>
                  </NanoFlex>
                }
              />
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
        <Modal show={this.state.showPasswordManagement} content={<PasswordManagementModal cancelAction={() => this.setState({ showPasswordManagement: false })} nextAction={() => this.setState({ showPasswordManagement: false })} />} />
      </StyledHeader>
    );
  }
}

export default Header;

// --- // Documentation // --- //
/*

import Header from './Header.js';

<Header />
*/
